import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectPaymentAction } from './payments.actions';
import { IPaymentsFeature } from './payments.feature.state';
import { getFailures, getIsLoading, getPayments, getSelectedPayment } from './payments.selectors';

@Injectable()
export class PaymentsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public payments$ = this.store.select(getPayments);
  public selectedPayment$ = this.store.select(getSelectedPayment);

  constructor(private store: Store<IPaymentsFeature>) {}

  public selectPayment(paymentId: number): void {
    this.store.dispatch(selectPaymentAction({ paymentId }));
  }
}
